/**
 * @enum {string}
 */
export default {
  /**
   * @type {string}
   */
  CIRCLE: 'Circle',
  /**
   * @type {string}
   */
  LINE_STRING: 'LineString',
  /**
   * @type {string}
   */
  MULTI_LINE_STRING: 'MultiLineString',
  /**
   * @type {string}
   */
  MULTI_POINT: 'MultiPoint',
  /**
   * @type {string}
   */
  MULTI_POLYGON: 'MultiPolygon',
  /**
   * @type {string}
   */
  POINT: 'Point',
  /**
   * @type {string}
   */
  POLYGON: 'Polygon',
  /**
   * @type {string}
   */
  RECTANGLE: 'Rectangle',
  /**
   * @type {string}
   */
  TEXT: 'Text'
};
